import { createSlice } from "@reduxjs/toolkit";

export const authorizedPersonSlice = createSlice({
  name: "authorizedPerson",
  initialState: {
    authorizedPersonDetails: [
      {
        apType: "",
        name: "",
        mobileNumber: "",
        email: "",
        idCardDoc: [],
        idCard: "",
        isOtpVerified: false,
      },
    ],
    updateTotalWeight: 0,
    truckDetails: [
      {
        truckDetails: {
          vehicleType: "",
          vehicleTypeOthers: "",
          engineNo: "",
          driverNumber: "",
          driverName: "",
          isDriverNumberVerifed: true,
          truckno: "",
          truckTracker: "",
          idCardNumber: "",
          idCardDoc: [],
        },
        commodityDetails: {
          commodity: "",
          variety: "",
          noofbags: "",
          weighinmetricton: "",
          weight: "",
        },
        documentDetails: [],
        invoiceData: {
          amount: "",
          date: null,
        },
      },
    ],
    verifiedPhone: [],
  },
  reducers: {
    setAuthorizedData: (
      state = authorizedPersonSlice?.initialState,
      action
    ) => {
      state.authorizedPersonDetails = action.payload;
    },

    updateTruckDetails: (state, action) => {
      const { index, fieldName, value } = action.payload;
      
      if (index >= 0 && index < state.truckDetails.length) {
        state.truckDetails[index][fieldName] = value;
      } else {
        state.truckDetails = [...state.truckDetails, action.payload];
      }
    },
    deleteTruckDetails: (state, action) => {
      const { index } = action.payload;
      const updatedTruckDetails = [...state.truckDetails];
      updatedTruckDetails.splice(index, 1);
      return {
        ...state,
        truckDetails: updatedTruckDetails,
      };
    },
    updateTotalWeight: (
      state = authorizedPersonSlice?.initialState,
      action
    ) => {
      
      state.updateTotalWeight = action?.payload;
    },
    resetTruckDetail: (state = authorizedPersonSlice?.initialState, action) => {
      state.truckDetails = action.payload;
    },

    setVerifiedPhoneNumber: (
      state = authorizedPersonSlice?.initialState,
      action
    ) => {
      state.verifiedPhone = action.payload;
    },
  },
});
export const {
  setAuthorizedData,
  updateTruckDetails,
  resetTruckDetail,
  updateTotalWeight,
  setVerifiedPhoneNumber,
  deleteTruckDetails,
} = authorizedPersonSlice.actions;
export default authorizedPersonSlice.reducer;
